import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { OrderStatus, OrderType } from 'src/app/@core/constants';
import { ColumnTable } from 'src/app/models/column-table';

import { Customer } from 'src/app/models/customer';
import { Filter } from 'src/app/models/filter';
import { FilterTable } from 'src/app/models/filter-table';
import { OrderFilter } from 'src/app/models/filters/order-filter';
import { Order } from 'src/app/models/order';
import { Paging } from 'src/app/models/page';
import { LoanService } from 'src/app/services/loan.service';
import { OrderService } from 'src/app/services/order.service';
import { ReportService } from 'src/app/services/report.service';

@Component({
  selector: 'app-customer-quotations',
  templateUrl: './customer-quotations.component.html',
  styleUrls: ['./customer-quotations.component.sass']
})
export class CustomerQuotationsComponent implements OnInit, OnChanges {

  @Input()
  customer: Customer = new Customer();
  @Output()
  getAmountOfOrders = new EventEmitter<number>();

  orders: Paging<Array<Order>> = new Paging([]);
  constructor(private orderService: OrderService, private datePipe: DatePipe, private reportService: ReportService) { }
  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if (this.customer.code) {
      await this.getOrders({ page: 0, pageSize: 10, value: {} });
    }
    this.getAmountOfOrders.emit(this.orders.totalElements);
  }

  ngOnInit(): void {
  }

  async getOrders(filter: Filter<OrderFilter>) {
    filter.value.customerCode = this.customer.code;
    filter.value.orderType = OrderType.QUOTATION;
    filter.value.status = OrderStatus.INITIAL;
    filter.value.start = this.datePipe.transform(filter.value.start, "yyyy-MM-dd HH:mm:ssZ") || filter.value.start;
    filter.value.end = this.datePipe.transform(filter.value.end, "yyyy-MM-dd 23:59:59Z") || filter.value.end
    this.orders = (await this.orderService.readOrders(filter).toPromise()).response;

  }

  getHeaders(): Array<ColumnTable> {
    return [
      new ColumnTable("code", "Número de Orden"),
      new ColumnTable("vendor", "Código Vendedor"),
      new ColumnTable("vendorName", "Vendedor"),
      new ColumnTable("branchCode", "Código de tienda"),
      new ColumnTable("branchName", "Tienda"),
      new ColumnTable("timeStamp", "Fecha", { type: "date" }),
      new ColumnTable('condition', "Tipo de Orden", { type: "badge", valueMap: this.getConditionMap() }),
      new ColumnTable("totals.netTotal", "Amount", { type: "currency" }),
      new ColumnTable("code", "Opciones", {
        type: 'action', actions: [
          {
            fn: async (order: Order) => {
              await this.printQuotation(order);
            },
            icon: 'fa fa-print',
            tooltip: 'Reimprimir',
            isDisabled: false
          }
        ]
      })
    ]
  }

  private async printQuotation(order: Order) {
    let completeOrder = await this.orderService.readerOrderCompleteProcess(order.code).toPromise();
    let reportsToPrint: Array<Blob> = [];
    if (completeOrder.response.loans.length > 0) {
      await Promise.all(completeOrder.response.loans.map(async (m) => reportsToPrint.push(await this.reportService.quotationPDF(order.code, order.salesOrgCode, m.code).toPromise())));
    } else {
      reportsToPrint.push(await this.reportService.quotationPDF(order.code, order.salesOrgCode).toPromise());
    }
    await this.reportService.printReports(...reportsToPrint);
  }

  getFilters(): Array<FilterTable> {
    return [
      new FilterTable("text", "Búsqueda General"),
      new FilterTable("start", "Fecha Inicial", { type: "date" }),
      new FilterTable("end", "Fecha Final", { type: "date" }),
    ]
  }

  private getConditionMap(): Map<string, string> {
    let result = new Map<string, string>();

    result.set("contado", "Contado");
    result.set("credito", "Crédito");

    return result;
  }
}
